import SelectItem from '@/common/interfaces/SelectItem';
import ApiService from '../../common/ApiService/ApiService';
import { HttpVerb } from '../../common/ApiService/HttpVerb';

const itineraryApiService = new ApiService('/api/ItineraryApiService/', {
  showLoading: false,
  cancel: true,
  returnData: true,
});

const departureApiService = new ApiService('/api/DepartureApiService/', {
  showLoading: false,
  cancel: true,
  returnData: true,
});

export const GetItineraries = async (destinationId: number): Promise<SelectItem[]> => {
  return await itineraryApiService.call(`GetByDestinationId?destinationId=${destinationId}`);
};

export const GetDates = async (itineraryId: number): Promise<SelectItem[]> => {
  return await itineraryApiService.call(`GetDates?itineraryId=${itineraryId}`);
};

export const GetDepartureUrl = async (departureId: number): Promise<string> => {
  return await departureApiService.call(
    `GetDepartureItineraryHeaderUrl?departureId=${departureId}`,
  );
};
